import useUser from "@saleor/hooks/useUser";
import { maybe } from "@saleor/misc";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import ReportPageComponent from "./components/ReportsPage/ReportsPage";
import { GenerateReportUrlQueryParams } from "./urls";

const RepostPage: React.FC = () => {
  const qs = parseQs(location.search.substr(1));
  const params: GenerateReportUrlQueryParams = qs;
  const user = useUser();

  return <ReportPageComponent params={params} user={maybe(() => user.user)} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Reports",
          description: "Reports page"
        })}
      />
      <Routes>
        <Route path={""} element={<RepostPage />} />
      </Routes>
    </>
  );
};

export default Component;
